import React, { useState } from "react";
import { signInWithGoogle } from "../firebase";
import { Container, Row, Col, Button, Card, Alert, Spinner } from "react-bootstrap";
import "./LoginPage.css"; // Import custom CSS if needed

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError("");
      await signInWithGoogle();
      console.log("User signed in successfully");
    } catch (error) {
      console.error("Login failed: ", error);
      
      // Provide more specific error messages
      let errorMessage = error.message;
      if (error.message.includes('api-key-not-valid')) {
        errorMessage = "Firebase API key is invalid. Please check your .env file and Firebase project settings.";
      } else if (error.message.includes('auth/unauthorized-domain')) {
        errorMessage = "This domain is not authorized. Please add 'localhost' to authorized domains in Firebase Console.";
      } else if (error.message.includes('popup-closed')) {
        errorMessage = "Sign-in popup was closed. Please try again.";
      } else if (error.message.includes('network')) {
        errorMessage = "Network error. Please check your internet connection.";
      } else if (error.message.includes('not authorized to access this application')) {
        errorMessage = "You are not authorized. Please contact admin for access.";
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="d-flex justify-content-center align-items-center vh-100">
      <Row className="w-100 justify-content-center">
        <Col xs={12} md={6} lg={4}>
          <Card className="text-center p-4 shadow-lg">
            <Card.Body>
              <div className="mb-4">
                <h1 className="mb-3 text-primary">Fairpatterns</h1>
                <h5 className="text-muted">Login to Processed on the tool</h5>
              </div>
              
              {error && (
                <Alert variant="danger" className="mb-4">
                  <Alert.Heading>Authentication Error</Alert.Heading>
                  <p className="mb-0">{error}</p>
                </Alert>
              )}
              

              
              <Button 
                variant="primary" 
                onClick={handleLogin} 
                className="w-100 py-2"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Signing in...
                  </>
                ) : (
                  <>
                    <i className="fab fa-google me-2"></i>
                    Sign in with Google
                  </>
                )}
              </Button>
              

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
